import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Loading from '../../../shared/loading';
import { Button, ButtonGroup } from './common/styles';

const SButtonGroup = styled(ButtonGroup)`
  span.loading-panel-inline {
    padding-top: 10px;
    margin-left: 20px;
  }
`;

export default function OptionsControl(props) {
  const [options, setOptions] = React.useState(props.options);
  const [frequenciesToUpdate, setFrequenciesToUpdate] = React.useState(props.frequenciesToUpdate);
  const loadingRef = React.useRef();
  const { updateOptionsFunction } = props;

  React.useEffect(() => {
    loadingRef.current && loadingRef.current.stop();
  });

  React.useEffect(() => {
    if (frequenciesToUpdate) {
      loadingRef.current.start();

      updateOptionsFunction(frequenciesToUpdate).then(() => {
        setOptions(frequenciesToUpdate);
        setFrequenciesToUpdate(null);
      });
    }
  }, [frequenciesToUpdate, updateOptionsFunction]);

  const isOptionIncluded = option => _.indexOf(options, option) !== -1;

  const updateOptions = option => {
    let newOptions = [];

    if (option === 'NEVER') {
      newOptions = [option];
    } else if (isOptionIncluded(option)) {
      newOptions = _.difference(options, [option]);
    } else {
      newOptions = _.difference(_.union(options, [option]), ['NEVER']);
    }

    if (_.isEmpty(newOptions)) {
      newOptions = ['NEVER'];
    }

    loadingRef.current.start();

    updateOptionsFunction(newOptions).then(({ data }) => {
      setOptions(newOptions);

      if (data.feedback_url) {
        window.location = data.feedback_url;
      }
    });
  };

  const frequencies = ['NOW', 'DAILY', 'WEEKLY', 'MONTHLY', 'NEVER'];
  const newFrequencies = ['NOW', 'DAILY', 'WEEKLY', 'NEVER'];

  if (_.indexOf(options, 'MONTHLY') !== -1) {
    return (
      <SButtonGroup id={props.id}>
        {frequencies.map(frequency => (
          <Button
            key={frequency}
            className={isOptionIncluded(frequency) ? 'active' : 'inactive'}
            onClick={() => updateOptions(frequency)}
          >
            {frequency}
          </Button>
        ))}
        <Loading variant="inline" ref={loadingRef} />
      </SButtonGroup>
    );
  }
  return (
    <SButtonGroup id={props.id}>
      {newFrequencies.map(frequency => (
        <Button
          key={frequency}
          className={isOptionIncluded(frequency) ? 'active' : 'inactive'}
          onClick={() => updateOptions(frequency)}
        >
          {frequency}
        </Button>
      ))}
      <Loading variant="inline" ref={loadingRef} />
    </SButtonGroup>
  );
}

OptionsControl.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateOptionsFunction: PropTypes.func.isRequired,
  frequenciesToUpdate: PropTypes.arrayOf(PropTypes.string),
};

OptionsControl.defaultProps = {
  frequenciesToUpdate: null,
};
